import utils from "@/stuff/Utils";
import { DocumentVisibility } from "./Enums";

export class SupplierDocumentSearchParameters {
    supplierID: number = 0;
    documentID: string = utils.emptyGuidValue;
    visibilities: Array<DocumentVisibility> = [];
}